import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center q-pa-md"
}
const _hoisted_2 = {
  key: 1,
  class: "text-body1 text-weight-bold q-mb-md"
}
const _hoisted_3 = {
  key: 0,
  class: "text-positive"
}
const _hoisted_4 = {
  key: 2,
  class: "text-body1"
}
const _hoisted_5 = {
  key: 0,
  class: "q-mb-sm"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_view_imports_btn = _resolveComponent("view-imports-btn")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_job_run_time_info = _resolveComponent("job-run-time-info")!
  const _component_app_user = _resolveComponent("app-user")!
  const _component_post_import_insights = _resolveComponent("post-import-insights")!
  const _component_message = _resolveComponent("message")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.status === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_icon, {
            name: "fa fa-spinner fa-spin",
            size: "3rem"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.isRunning)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createTextVNode(" Importing Posts "),
                _createVNode(_component_q_icon, { name: "fa fa-spinner fa-spin" })
              ]))
            : (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                key: 1,
                label: "Last Post Import",
                color: "grey-2",
                "text-color": "dark",
                class: "text-body1 text-weight-bold",
                rounded: "",
                unelevated: "",
                "no-caps": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_view_imports_btn, {
                    "account-id": _ctx.postImport.accountId,
                    platform: _ctx.platform,
                    label: "View All",
                    class: "full-width",
                    align: "center",
                    "no-caps": ""
                  }, null, 8, ["account-id", "platform"])
                ]),
                _: 1
              })),
          (_ctx.jobRun)
            ? (_openBlock(), _createBlock(_component_job_run_time_info, {
                key: 2,
                "job-run": _ctx.jobRun,
                class: "text-grey-7 text-body1 on-right"
              }, null, 8, ["job-run"]))
            : _createCommentVNode("", true)
        ])),
    (_ctx.isRunning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_app_user, null, {
            default: _withCtx(({ isServiceProvider, isCustomer, isClient }) => [
              (isServiceProvider || isCustomer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " So far, " + _toDisplayString(_ctx.postImport.numPosts) + " posts have been imported. ", 1))
                : _createCommentVNode("", true),
              isCustomer
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " You will be notified when all of the posts have been imported. "))
                : _createCommentVNode("", true),
              isClient
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No further action is needed for " + _toDisplayString(_ctx.platform) + ". ", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : (_ctx.succeeded && _ctx.jobRun)
        ? (_openBlock(), _createBlock(_component_post_import_insights, {
            key: 3,
            "post-import": _ctx.postImport,
            "job-run": _ctx.jobRun
          }, null, 8, ["post-import", "job-run"]))
        : (_ctx.failed)
          ? (_openBlock(), _createBlock(_component_message, {
              key: 4,
              type: "negative"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" A problem occurred during the import. ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
  ]))
}